import { AxiosResponse } from 'axios'

export type Response = { result?: AxiosResponse<any>; error?: any }

export type TMonth = { id: string; name: { th: string; en: string } }
export function useMonth() {
    const month = [
        { id: '1', name: { th: 'มกราคม', en: 'January' } },
        { id: '2', name: { th: 'กุมภาพันธ์', en: 'February' } },
        { id: '3', name: { th: 'มีนาคม', en: 'March' } },
        { id: '4', name: { th: 'เมษายน', en: 'April' } },
        { id: '5', name: { th: 'พฤษภาคม', en: 'May' } },
        { id: '6', name: { th: 'มิถุนายน', en: 'June' } },
        { id: '7', name: { th: 'กรกฎาคม', en: 'July' } },
        { id: '8', name: { th: 'สิงหาคม', en: 'August' } },
        { id: '9', name: { th: 'กันยายน', en: 'September' } },
        { id: '10', name: { th: 'ตุลาคม', en: 'October' } },
        { id: '11', name: { th: 'พฤศจิกายน', en: 'November' } },
        { id: '12', name: { th: 'ธันวาคม', en: 'December' } },
    ]

    return [month]
}
